<div id="guess_the_hynn_container" (doubletap)="onDoubleTap()" class="guess-the-hymn-container">
  <div *ngIf="!twoPlayerActive && !singlePlayerActive" class="home-wrapper">
    <button class="push-button play-btn button-white menu-btn push-button-enabled"
            (click)="toggleMenu()">
      <mat-icon class="question-icon"
      >menu</mat-icon>
    </button>

    <div class="logo-container">
      <img src="assets/icons/hymn-dash.png" alt="App Logo" class="logo" />
    </div>

    <h1 class="title">{{translation.guess_the_hymn.title}}</h1>

    <div class="mode-buttons">
      <button class="push-button button-blue push-button-enabled player-btn"
              (click)="start1PlayerGame()">
        {{translation.guess_the_hymn.single_player}}
        &nbsp;<mat-icon>face</mat-icon>
      </button>

      <button class="push-button button-red push-button-enabled player-btn"
              (click)="start2PlayerGame()">
        {{translation.guess_the_hymn.two_player}}
        &nbsp;<mat-icon>face</mat-icon><mat-icon>face</mat-icon>
      </button>
    </div>

    <div class="scoreboard">
      <div class="score-title">
        {{translation.guess_the_hymn.scoreboard_title}}
      </div>
      <div class="score-row">
        <span>{{translation.all_hymns}}</span>
        <span>{{topScoreAllHymns}}</span>
      </div>
      <div class="score-row">
        <span>{{translation.favorites}}</span>
        <span>{{topScoreFavoriteHymns}}</span>
      </div>
    </div>

    <div class="hymn-mode">
      <div class="toggle-buttons">
        <button class="push-button
          push-button-enabled
          button-bar-btn
          button-bar-left"
          [class.button-white]="!allHymns"
          [class.button-green-glow]="allHymns"
                (click)="setAllHymns(true)">{{translation.all_hymns}}</button>
        <button class="push-button
          push-button-enabled
          button-bar-btn
          button-bar-right"
          [class.button-white]="allHymns"
          [class.button-green-glow]="!allHymns"
                (click)="setAllHymns(false)">{{translation.favorites}}</button>
      </div>
    </div>
  </div>

  <div *ngIf="singlePlayerActive" class="full-size">
    <app-single-player
      (exit)="exitGame();"
      [topScore]="allHymns? topScoreAllHymns : topScoreFavoriteHymns"
      (score)="onScore($event)"
      [favorites]="!allHymns"
      class="full-size"></app-single-player>
  </div>

  <div *ngIf="twoPlayerActive" class="full-size full-container-height">
    <app-two-player
      (exit)="exitGame();"
      [favorites]="!allHymns"
      class="full-size"></app-two-player>
  </div>

</div>
